import axios from 'axios';
import { wrapAxios } from '../../axios';
import { ICommonOrder, ICommonRemoveItemFromCartRequest } from '@cuspar/ywt.ch.model';

export const orderAPI = {
  getOrderById: async (orderId: string, checkAvailability = false) => {
    const url = checkAvailability ? `/orders/${orderId}?checkAvailability=true` : `/orders/${orderId}`;
    return wrapAxios(() => axios.get<ICommonOrder>(url));
  },
  getMyOrders: async (page: number = 1, size: number = 10) => {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    return wrapAxios(() => axios.get<ICommonOrder[]>(`/orders/myOrders?${params.toString()}`));
  },
  removeItemFromOrder: async (orderId: string, item: ICommonRemoveItemFromCartRequest) => {
    return wrapAxios(() => axios.delete<ICommonOrder>(`/orders/${orderId}/items`, { data: item }));
  },
  deleteOrderById: async (orderId: string) => {
    return wrapAxios(() => axios.delete(`/orders/${orderId}`));
  },
  forceProcessOrder: async (orderId: string) => {
    return wrapAxios(() => axios.post(`/orders/${orderId}/forceProcessOrder`));
  },
  applyCoupon: async (orderId: string, coupon: string) => {
    return wrapAxios(() => axios.post(`/orders/${orderId}/applyCoupon`, { coupon }));
  },
  removeCoupon: async (orderId: string) => {
    return wrapAxios(() => axios.post(`/orders/${orderId}/removeCoupon`));
  },
  createRenewalOrder: async (domains: string[]) => {
    return wrapAxios(() => axios.post<ICommonOrder>('/orders/renewals', { domains }));
  },
  createRestoreOrder: async (domain: string) => {
    return wrapAxios(() => axios.post<ICommonOrder>('/orders/restores', { domain }));
  },
  consolidateRenewalOrders: async () => {
    return wrapAxios(() => axios.post<ICommonOrder>('/orders/renewals/consolidate'));
  },
  createPaymentIntentPublic: async (orderId: string, token: string) => {
    return wrapAxios(() => axios.post<{ clientSecret: string; order: ICommonOrder }>(`/orders/public/${orderId}/createPaymentIntent`, { token }));
  },
  finalizeOrder: async (orderId: string, paymentMethodId?: string | null) => {
    return wrapAxios(() => axios.put<ICommonOrder>(`/orders/${orderId}/finalize`, { paymentMethodId }));
  },
};
